<script>
import ContactCard from 'components/views/my/contact/elements/Card.svelte';


import SvelteSeo from 'svelte-seo';


const contacts = [
]


</script>


<style>
	

</style>



<SvelteSeo
	title='Contact | AHG Coaches Portal'
	description='Contact!'
/>



<section class="hero bg-grey">

	<div class="hero-body">

		<div class="container">

			<p class="hero-subtitle has-text-centered">
				Contact
			</p>

		</div>

	</div>
	
</section>



<section class="section">

	<div class="container">

		<div class="columns is-centered">

			<div class="column is-9-desktop is-10-tablet is-12-mobile">

				<div class="columns is-variable is-3 is-mobile is-multiline is-centered">

					{#each contacts as contact}

						<div class="column is-6-desktop is-12-touch">

							<ContactCard {contact} />

						</div>

					{/each}

				</div>

			</div>

		</div>

	</div>

</section>

<!-- email: donotreply@atlantichockeygroup.com -->

